import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useSnackbar } from "../../../contexts/SnackbarContext";
import { buildAiHubTriageResultPath } from "../constants";

type TriageResultRowActionsProps = Readonly<{
  resultId: string;
}>;

export default function TriageResultRowActions({
  resultId,
}: TriageResultRowActionsProps) {
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleView = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    navigate(buildAiHubTriageResultPath(resultId));
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleTerminate = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    handleCloseMenu();
    showMessage("Terminate flow is coming soon.", "info");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        gap: 0.25,
      }}
    >
      <IconButton
        aria-label={`View triage result ${resultId}`}
        size="small"
        sx={{ p: 0.75 }}
        onClick={handleView}
      >
        <VisibilityOutlinedIcon sx={{ fontSize: 18, color: "#A6A6A6" }} />
      </IconButton>
      <IconButton
        aria-label="More actions"
        size="small"
        sx={{ p: 0.75 }}
        onClick={handleOpenMenu}
      >
        <MoreVertIcon sx={{ fontSize: 18, color: "#A6A6A6" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              minWidth: 160,
              borderRadius: "8px",
              boxShadow:
                "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
            },
          },
        }}
      >
        <MenuItem
          onClick={handleTerminate}
          sx={{
            py: 1,
            px: 1.5,
            fontSize: "0.875rem",
            fontWeight: 500,
          }}
        >
          Terminate Flow
        </MenuItem>
      </Menu>
    </Box>
  );
}
